// Thin typed wrapper around Segment's window.analytics

declare global {
  interface Window {
    analytics?: {
      load(writeKey: string, options?: Record<string, unknown>): void;
      track(event: string, properties?: Record<string, unknown>): void;
      page(name?: string, properties?: Record<string, unknown>): void;
      identify(traits: Record<string, unknown>): void;
      identify(userId: string, traits?: Record<string, unknown>): void;
    };
    fbq?: (...args: unknown[]) => void;
  }
}

// ── Event names ──────────────────────────────────────────────
export const EVENTS = {
  QUIZ_STARTED: 'Quiz Started',
  QUIZ_GOAL_DONE: 'Quiz Goal Done',
  QUIZ_INDUSTRY_DONE: 'Quiz Industry Done',
  QUIZ_FINANCIALS_DONE: 'Quiz Financials Done',
  QUIZ_DEBT_DONE: 'Quiz Debt Done',
  QUIZ_AGE_DONE: 'Quiz Age Done',
  QUIZ_LIFE_STATUS_DONE: 'Quiz Life Status Done',
  QUIZ_INCOME_DONE: 'Quiz Income Done',
  QUIZ_COMPLETED: 'Quiz Completed',
  QUIZ_PAGE_VIEWED: 'Quiz Page Viewed',
  RENTAL_QUIZ_SHOWN: 'Rental Quiz Shown',
  RENTAL_QUESTION_ANSWERED: 'Rental Question Answered',
  RENTAL_INTERSTITIAL_SHOWN: 'Rental Interstitial Shown',
  RENTAL_QUIZ_STARTED: 'Rental Quiz Started',
  RENTAL_QUIZ_COMPLETED: 'Rental Quiz Completed',
  RENTAL_RESULT_SHOWN: 'Rental Result Shown',
  EXPRESS_PAGE_VIEWED: 'Express Page Viewed',
  EXPRESS_INPUT_STARTED: 'Express Input Started',
  EXPRESS_GUARDRAIL_BLOCKED: 'Express Guardrail Blocked',
  AUTH_MODAL_SHOWN: 'Auth Modal Shown',
  EXPRESS_LINK_CLICKED: 'Express Link Clicked',
  DESCRIBE_OWN_WORDS_CLICKED: 'Describe Own Words Clicked',
  TRUST_PAGE_VIEWED: 'Trust Page Viewed',
  EXPRESS_SUBMITTED: 'Express Submitted',
  EXAMPLE_CHIP_CLICKED: 'Example Chip Clicked',
  AUTH_SUBMITTED: 'Auth Submitted',
  PLAN_GENERATED: 'Plan Generated',
  PLAN_GENERATION_FAILED: 'Plan Generation Failed',
  ACTIVATE_PLAN_CLICKED: 'Activate Plan Clicked',
  CREATE_ANOTHER_PLAN_CLICKED: 'Create Another Plan Clicked',
  PLAN_BREAKDOWN_VIEWED: 'Plan Breakdown Viewed',
  PLAN_AMOUNT_EDITED: 'Plan Amount Edited',
  PLAYGROUND_CREATED: 'Playground Created',
  PLAYGROUND_CREATION_FAILED: 'Playground Creation Failed',
  BLUEPRINT_VIEW_TOGGLED: 'Blueprint View Toggled',
  BLUEPRINT_MAP_REFRESHED: 'Blueprint Map Refreshed',
  RESULTS_PAGE_VIEWED: 'Results Page Viewed',
  PLAN_PAGE_VIEWED: 'Plan Page Viewed',
  ACTIVATE_PAGE_VIEWED: 'Activate Page Viewed',
  SEE_BREAKDOWN_CLICKED: 'See Breakdown Clicked',
  ACTIVATE_BLUEPRINT_CLICKED: 'Activate Blueprint Clicked',
  SEQUENCE_SIGNUP_CLICKED: 'Sequence Signup Clicked',
  TAXES_QUIZ_SHOWN: 'Taxes Quiz Shown',
  TAXES_QUIZ_CTA_CLICKED: 'Taxes Quiz CTA Clicked',
  TAXES_QUIZ_STARTED: 'Taxes Quiz Started',
  TAXES_QUESTION_ANSWERED: 'Taxes Question Answered',
  TAXES_QUIZ_COMPLETED: 'Taxes Quiz Completed',
  TAXES_RESULT_SHOWN: 'Taxes Result Shown',
  TAXES_AUTH_SUBMITTED: 'Taxes Auth Submitted',
  STRESS_QUIZ_SHOWN: 'Stress Quiz Shown',
  STRESS_QUIZ_STARTED: 'Stress Quiz Started',
  STRESS_QUESTION_ANSWERED: 'Stress Question Answered',
  STRESS_QUIZ_COMPLETED: 'Stress Quiz Completed',
  STRESS_RESULT_SHOWN: 'Stress Result Shown',
  ADHD_QUIZ_SHOWN: 'ADHD Quiz Shown',
  ADHD_QUIZ_CTA_CLICKED: 'ADHD Quiz CTA Clicked',
  ADHD_QUIZ_STARTED: 'ADHD Quiz Started',
  ADHD_QUESTION_ANSWERED: 'ADHD Question Answered',
  ADHD_QUIZ_COMPLETED: 'ADHD Quiz Completed',
  ADHD_RESULT_SHOWN: 'ADHD Result Shown',
  WELLBEING_QUIZ_SHOWN: 'Wellbeing Quiz Shown',
  WELLBEING_QUIZ_ABANDONED: 'Wellbeing Quiz Abandoned',
  WELLBEING_QUESTION_ANSWERED: 'Wellbeing Question Answered',
  WELLBEING_QUIZ_STARTED: 'Wellbeing Quiz Started',
  WELLBEING_QUIZ_COMPLETED: 'Wellbeing Quiz Completed',
  WELLBEING_AUTH_SUBMITTED: 'Wellbeing Auth Submitted',
  WELLBEING_RESULT_SHOWN: 'Wellbeing Result Shown',
  WELLBEING_QUIZ_CTA_CLICKED: 'Wellbeing Quiz CTA Clicked',
} as const;

// ── Wrappers ─────────────────────────────────────────────────
export function track(event: string, properties?: Record<string, unknown>) {
  window.analytics?.track(event, properties);
}

export function page(name?: string, properties?: Record<string, unknown>) {
  window.analytics?.page(name, properties);
}

export function identify(email: string, traits?: Record<string, unknown>) {
  window.analytics?.identify({ email, ...traits });
}
